<template lang="pug">
div
  .row
    .col.s12.left-align
      router-link.waves-effect.waves-teal.btn(:to='{name: "inventory-upload", params: {inventoryName: $route.params.inventoryName}}')
        | Upload
        i.material-icons.right file_upload
  .row
    .col.s12
      inventory-products(
        :inventory='inventory',
        :contents='mutableInventory.productVariants',
        :inventoryName='$route.params.inventoryName'
      )
</template>
<script>
import InventoryProducts from '@/components/page-inventory-products'

export default {
  props: ['inventory'],
  data () {
    return {
      interval: null,
      mutableInventory: {
        id: null,
        name: null,
        productVariants: []
      }
    }
  },
  created () {
    this.getInventoryContents()
    this.interval = setInterval(() => {
      this.getInventoryContents()
    }, 30000)
  },
  destroyed () {
    clearInterval(this.interval)
  },
  computed: {
    supplier () {
      return this.$store.state.profile.supplier
    }
  },
  watch: {
    'inventory.id' () {
      this.getInventoryContents()
    }
  },
  methods: {
    getInventoryContents () {
      if (!this.supplier || !this.inventory.id) {
        return
      }

      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        this.$http
          .get(
            `${this.$config.API_URL}/suppliers/${this.supplier.id}/inventories/${this.inventory.id}`,
            {
              headers: {
                authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then((result) => {
            this.mutableInventory = result.data
          })
      })
    }
  },
  components: {
    InventoryProducts
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-inventory-details.vue